import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShareX = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 1200 1226.37",
	xmlns: "http://www.w3.org/2000/svg",
	width: 2446,
	height: 2500,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M714.163 519.284L1160.89 0h-105.86L667.137 450.887 357.328 0H0l468.492 681.821L0 1226.37h105.866l409.625-476.152 327.181 476.152H1200L714.137 519.284zM569.165 687.828l-47.468-67.894-377.686-540.24h162.604l304.797 435.991 47.468 67.894 396.2 566.721H892.476L569.165 687.854z" })
});
export default SvgShareX;
